export default __webpack_public_path__ + "static/media/propozues_kryeministria.90a6ac45.png";